/*
  「보미건설 안전관리」 앱 안에서 열렸는가 (DOC-140 · 사용자 결정 2026-10-29 「안전만 보이게」).

  협력사 앱(`partners-app/`)은 이 포털을 웹뷰로 태우고 UA 끝에 `BomiSafeApp/<버전>` 을 붙인다. 앱 안에서는
  포털이 **안전 앱**으로 선다 — 첫 화면 머리말이 앱 이름이고, 메뉴·홈·주소가 안전 갈래(아래 키)로 좁혀진다.
  견적·일보·검측 같은 다른 일은 웹 포털(partners.bomienc.com)에서 그대로 한다.

  ★ 화면에서 가리는 일이다 — 권한이 아니다. 판정은 지금처럼 서버가 매 요청 한다.
*/

/** 앱 웹뷰가 붙이는 UA 이름(`partners-app/src/App.tsx` 의 `APP_UA`). 둘이 같은 글자여야 한다. */
const SAFE_APP_UA = 'BomiSafeApp/';

export const IN_SAFE_APP: boolean =
  typeof navigator !== 'undefined' && navigator.userAgent.includes(SAFE_APP_UA);

/** 앱의 이름 — 첫 화면 머리말과 머리줄의 빈자리에 쓴다. 스토어 이름(`partners-app/app.json`)과 같다. */
export const SAFE_APP_TITLE = '보미건설 안전관리';

/** 앱에서 서는 메뉴 키(`lib/menu.ts`). 협력사는 TBM·교육(`safety`), 모두가 점검·시정조치(`safety-inspections`). */
export const SAFE_APP_MENU_KEYS: ReadonlySet<string> = new Set(['safety', 'safety-inspections']);

/**
 * 앱에서 열 수 있는 주소인가. 메뉴에 없는 곳이 알림·링크로 들어와도 안전 밖으로 새지 않게 홈(= 안전)으로 돌린다.
 * 홈과 마이페이지(로그아웃 · 내 정보)는 갈래와 무관한 자리라 열어 둔다.
 */
export function isSafeAppPath(pathname: string): boolean {
  if (pathname === '/' || pathname === '/home' || pathname === '/mypage') return true;
  const site = /^\/sites\/[^/]+\/([^/]+)/.exec(pathname);
  return site?.[1] !== undefined && SAFE_APP_MENU_KEYS.has(site[1]);
}
